import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEEASSESSMENT,
  DELETE_EMPLOYEEASSESSMENT,
  UPDATE_EMPLOYEEASSESSMENT,
  ADD_NEW_EMPLOYEEASSESSMENT,
} from "./actionType";

import {
  getEmployeeAssessmentSuccess,
  getEmployeeAssessmentFail,
  deleteEmployeeAssessmentSuccess,
  deleteEmployeeAssessmentFail,
  updateEmployeeAssessmentSuccess,
  updateEmployeeAssessmentFail,
  addEmployeeAssessmentSuccess,
  addEmployeeAssessmentFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeAssessmentApi,
  getEmployeeAssessmentApi,
  updateEmployeeAssessmentApi,
  deleteEmployeeAssessmentApi,
  addNewEmployeeAssessmentApi
} from "../../helpers/backend_helper";

function* getEmployeeAssessment({ payload: employeeAssessment }) {
  try {
    const response = yield call(getEmployeeAssessmentApi, employeeAssessment);
    yield put(getEmployeeAssessmentSuccess(GET_EMPLOYEEASSESSMENT, response.data));
  } catch (error) {
    yield put(getEmployeeAssessmentFail(GET_EMPLOYEEASSESSMENT, error));
  }
}

function* onUpdateEmployeeAssessment({ payload: employeeAssessment }) {
  try {
    if (employeeAssessment.setApprove) {
      const response = yield call(approveEmployeeAssessmentApi, employeeAssessment);
      yield put(updateEmployeeAssessmentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeAssessmentApi, employeeAssessment);
      yield put(updateEmployeeAssessmentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeAssessmentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeAssessment({ payload: employeeAssessment }) {
  try {
    const response = yield call(deleteEmployeeAssessmentApi, employeeAssessment);
    yield put(deleteEmployeeAssessmentSuccess({ employeeAssessment, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeAssessmentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeAssessment({ payload: employeeAssessment }) {
  try {
    const response = yield call(addNewEmployeeAssessmentApi, employeeAssessment);
    yield put(addEmployeeAssessmentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeAssessmentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeAssessment() {
  yield takeEvery(GET_EMPLOYEEASSESSMENT, getEmployeeAssessment);
}

export function* watchUpdateEmployeeAssessment() {
  yield takeEvery(UPDATE_EMPLOYEEASSESSMENT, onUpdateEmployeeAssessment);
}

export function* watchDeleteEmployeeAssessment() {
  yield takeEvery(DELETE_EMPLOYEEASSESSMENT, onDeleteEmployeeAssessment);
}

export function* watchAddNewEmployeeAssessment() {
  yield takeEvery(ADD_NEW_EMPLOYEEASSESSMENT, onAddNewEmployeeAssessment);
}

function* employeeAssessmentSaga() {
  yield all([
    fork(watchGetEmployeeAssessment),
    fork(watchDeleteEmployeeAssessment),
    fork(watchUpdateEmployeeAssessment),
    fork(watchAddNewEmployeeAssessment)
  ]);
}

export default employeeAssessmentSaga;
